import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setToast } from "../../redux/slice/system";
import {
  setDiagramDateRange,
  setDiagramFilter,
} from "../../redux/slice/diagram";
import { useFilterList, usePop } from "../../components/hooks";

import ModuleBreadCrumb from "../../components/breadCrumb";
import ModulePopDiagram from "./popDiagram";
import { copyToClipboard } from "../../service/common";
import { rootUrl } from "../../service/runtimeUrl";
import { option_system_web } from "../../service/option/common";
import { option_diagram } from "../../service/option/diagram";

import HomeCss from "../../styles/components/home.module.scss";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

export default function BackHome(props) {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [{ key: 1, label: "功能總覽" }];
  const [systemWeb, setSystemWeb] = useState(
    option_system_web[0]?.value || null
  );
  const [moduleData, setModuleData] = useState({ term: "", data: null });
  const { getFilterTreeData } = useFilterList();
  const { isPop, popOption, openPop, closePop, renderDialog } = usePop([
    {
      key: "view",
      title: (props) => props?.data?.label,
      isOpen: false,
    },
  ]);

  const listData = useMemo(
    () =>
      getFilterTreeData({
        data: moduleData.data,
        filterKey: "label",
        serachTerm: moduleData.term,
      }) || [],
    [moduleData]
  );

  useEffect(() => {
    let temp = option_diagram.filter((item) =>
      item.systemWeb.includes(systemWeb)
    );
    setModuleData((state) => ({
      ...state,
      data: temp,
    }));
  }, [systemWeb]);

  const copyText = ({ main, sub }) => {
    if (sub.api) {
      let url = `${rootUrl}iframe/single/${systemWeb}/${main.key}_${sub.key}`;
      copyToClipboard({
        text: url,
        errorAction: () =>
          dispatch(
            setToast({
              severity: "error",
              summary: "複製失敗",
              detail: "",
            })
          ),
      });

      dispatch(
        setToast({
          severity: "success",
          summary: "已複製連結",
          detail: sub.label,
        })
      );
    } else {
      dispatch(
        setToast({
          severity: "error",
          summary: "複製失敗",
          detail: "",
        })
      );
    }
  };

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3">功能總覽</h2>

      <div className="flex mb-2">
        <InputText
          value={moduleData.term}
          placeholder="關鍵字查詢"
          onChange={(e) =>
            setModuleData((state) => ({ ...state, term: e.target.value }))
          }
        />
        <Button
          type="button"
          icon="pi pi-refresh"
          className="p-button-secondary p-button-sm ml-2"
          onClick={() => setModuleData((state) => ({ ...state, term: "" }))}
        />

        <Dropdown
          className="w-15rem ml-auto"
          value={systemWeb}
          options={option_system_web}
          placeholder="選擇系統"
          onChange={(e) => setSystemWeb(e.value)}
        />
      </div>

      <div>
        {listData.length === 0 && moduleData.data !== null && (
          <div className="text-center text-lg text-red-400 bg-white border-1 border-200 border-round-md p-3">
            查無資料
          </div>
        )}
        {listData.map((main, mIdx) => (
          <div
            key={`main_${main.key}`}
            className={classNames(
              "bg-white border-1 border-200 border-round-md px-2 py-1",
              {
                "mt-2": mIdx !== 0,
              }
            )}
          >
            <div className="flex align-items-center mb-1">
              <div className="text-xl font-bold my-2">
                {main.label}
                {main.isUnFinish && (
                  <span className="text-red-400 ml-2">(未完成)</span>
                )}
              </div>
            </div>

            <div className="grid">
              {main.child.map((sub) => (
                <div
                  key={`main_${main.key}_${sub.key}`}
                  className="col-4 md:col-3"
                >
                  <div className="flex flex-column h-full bg-blue-50 border-1 border-200 border-round-md p-2">
                    <div className="flex-auto text-lg">{sub.label}</div>
                    <div className="flex flex-column sm:flex-row mt-2">
                      <Button
                        className="p-button-info p-button-sm w-auto px-2 py-1 my-1"
                        label="複製連結"
                        onClick={() => copyText({ main, sub })}
                      />
                      <Button
                        className="p-button-sm w-auto px-2 py-1 sm:ml-2 my-1"
                        label="查看"
                        onClick={() => {
                          dispatch(setDiagramDateRange({}));
                          dispatch(setDiagramFilter({}));
                          openPop({ type: "view", data: sub });
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {renderDialog({
        className: "w-11 sm:w-10",
        children: (
          <>
            {isPop.view?.isOpen && (
              <ModulePopDiagram
                popPreOption={popOption}
                closePrePop={closePop}
                systemWeb={systemWeb}
              />
            )}
          </>
        ),
      })}
    </>
  );
}
